import { SITE_URL, useSeo } from "@/hooks/useSeo";
import { memeItems } from "@/mocks/memes";
import { siteFaqs } from "@/mocks/site";
import HeroSection from "@/pages/home/components/HeroSection";
import HotStrip from "@/pages/home/components/HotStrip";
import CategorySection from "@/pages/home/components/CategorySection";
import LatestSection from "@/pages/home/components/LatestSection";
import CommentWall from "@/pages/home/components/CommentWall";
import ErchuangSection from "@/pages/home/components/ErchuangSection";
import FaqSection from "@/pages/home/components/FaqSection";
import BrandSection from "@/pages/home/components/BrandSection";

export default function Home() {
  useSeo({
    title: "131吃瓜 - 最新梗图和表情包合集，神评论与网友二创一站看",
    description:
      "131吃瓜汇集最新梗图、表情包、神评论与网友二创，梗合集每日更新。逛一圈就能接住聊天里的热梗，配图顺手存走，最新梗都在这儿。",
    keywords: "131吃瓜,梗图,表情包,神评论,网友二创,梗合集",
    path: "/",
    jsonLd: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": `${SITE_URL}/#webpage`,
          url: `${SITE_URL}/`,
          name: "131吃瓜 - 最新梗图和表情包合集",
          description: "最新梗图、表情包、神评论与网友二创，梗合集每日更新。",
          inLanguage: "zh-CN",
          isPartOf: { "@id": `${SITE_URL}/#website` },
        },
        {
          "@type": "ItemList",
          name: "今日最新收录",
          itemListElement: memeItems.slice(0, 10).map((item, index) => ({
            "@type": "ListItem",
            position: index + 1,
            url: `${SITE_URL}/meme/${item.id}`,
            name: item.title,
          })),
        },
        {
          "@type": "FAQPage",
          mainEntity: siteFaqs.map((faq) => ({
            "@type": "Question",
            name: faq.q,
            acceptedAnswer: { "@type": "Answer", text: faq.a },
          })),
        },
      ],
    },
  });

  return (
    <>
      <HeroSection />
      <HotStrip />
      <CategorySection />
      <LatestSection />
      <CommentWall />
      <ErchuangSection />
      <FaqSection />
      <BrandSection />
    </>
  );
}